import { EventEmitter } from 'events'

export const tooltipEmitter = new EventEmitter()
export const HELPDESK_URL = process.env.REACT_APP_HELPDESK_URL
export const SUPPORTED_HELPDESK_TEAM_TYPE = ['enterprise_self_serve', 'saas', 'agency_partners']
export const TOOLTIP_DOMAIN_EVENT = {
    helpdesk: {
        show: 'show-helpdesk-tooltip',
        close: 'hide-helpdesk-tooltip',
    },
} as const
type TooltipDomain = keyof typeof TOOLTIP_DOMAIN_EVENT

let tooltipTimeout: NodeJS.Timeout | null = null

/**
 *    @description emit event tooltip to be listened in specific component
 *    @param domain identifier among all tooltip
 *    @param timeout hide the tooltip after reaching timeout, default is `5000`
 */
export const emitShowTooltip = (domain: TooltipDomain, timeout = 5000) => {
    try {
        tooltipEmitter.emit(TOOLTIP_DOMAIN_EVENT[domain].show)

        // Clear any existing timeout before setting a new one
        if (tooltipTimeout) {
            clearTimeout(tooltipTimeout)
        }

        // timeout to hide the tooltip
        tooltipTimeout = setTimeout(() => {
            tooltipEmitter.emit(TOOLTIP_DOMAIN_EVENT[domain].close)
            tooltipTimeout = null
        }, timeout)
    } catch {
        // clean up when try failed
        tooltipEmitter.emit(TOOLTIP_DOMAIN_EVENT[domain].close)
        if (tooltipTimeout) {
            clearTimeout(tooltipTimeout)
            tooltipTimeout = null
        }
    }
}

/**
 *    @description manually cancel timeout on tooltip emitter, usually needed when component unmounting
 */
export const cancelTooltipEmitter = () => {
    if (tooltipTimeout) {
        clearTimeout(tooltipTimeout)
        tooltipTimeout = null
    }
}
